import { createContext, useContext } from "react";
import defaultFlowConfig from "../config/flowConfig.json";
import defaultQuestions from "../config/questions.json";

export const ConfigContext = createContext();

export const useConfig = () => useContext(ConfigContext);

export const ConfigProvider = ({ children }) => {
  const configData = defaultFlowConfig;
  const logo = "logo.png";
  const userQuestions = defaultQuestions;

  return (
    <ConfigContext.Provider
      value={{
        logo,
        configData,
        userQuestions,
      }}
    >
      {children}
    </ConfigContext.Provider>
  );
};
